import i18nMain from "./vi/i18nMain";
// import i18nValidate from './vi/i18nValidate';
import i18nCommon from "./vi/i18nCommon";
import i18nEnum from "./vi/i18nEnum";
import i18nComponent from "./vi/i18nComponent";

import i18nPages from "./vi/i18nPages";

import i18nBaseForm from "./vi/i18nBaseForm";

import i18nNotification from "./vi/i18nNotification";

//import i18nCommonVI from "./vi/i18nCommon";

import i18nDashboardVI from "./vi/i18nDashboard";
import i18nRequestVI from "./vi/i18nRequest";
import i18nExecuteVI from "./vi/i18nExecute";
import i18nRequestTypeFromVI from "./vi/i18nRequestType.js";
import i18nReport from "./vi/i18nReport";
import i18nSearchPage from "./vi/i18nSearchPage";
import i18nValidate from "./vi/i18nValidate";

export default {
  vi: {
    i18nMain,
    // i18nValidate,
    i18nCommon,
    i18nComponent,
    i18nEnum,
    i18nPages,
    i18nBaseForm,
    i18nNotification,
    i18nReport,
    i18nSearchPage,

    i18nDashboard: i18nDashboardVI,
    i18nRequest: i18nRequestVI,
    i18nExecute: i18nExecuteVI,
    i18nRequestType: i18nRequestTypeFromVI,
    i18nValidate: i18nValidate,
  }
};
